import { html, css, LitElement } from "lit";
export class A2kStack extends LitElement {
    render() {
        return html `<div id="stack">
      <slot></slot>
    </div>`;
    }
}
A2kStack.styles = css `
    #stack {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      gap: var(--stack-spacing-top) !important;
    }
  `;
